import './ProjectBrochure.css';

export default function ProjectBrochure({ project }) {
  const { brochure, name } = project;
  if (!brochure?.file) return null;

  return (
    <section className="pd-section pd-brochure">
      <div className="pd-brochure__inner">
        {brochure.thumb && (
          <div className="pd-brochure__thumb">
            <img src={brochure.thumb} alt={`${name} brochure cover`} loading="lazy" />
          </div>
        )}
        <div className="pd-brochure__body">
          <p className="pd-eyebrow">{brochure.label || 'Project Brochure'}</p>
          <h2 className="pd-title">Take the details <em>with you</em></h2>
          <p className="pd-brochure__text">
            View the {name} {(brochure.label || 'brochure').toLowerCase()} for the
            unit mix, features and contact details.
          </p>
          <div className="pd-brochure__actions">
            <a
              href={brochure.file}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn--outline"
            >
              View {brochure.label || 'Brochure'}
            </a>
            <a href={brochure.file} download className="btn btn--dark">
              Download
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
